import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=4b188290&scoped=true"
import script from "./CountryFlag.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryFlag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=4b188290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b188290",
  null
  
)

export default component.exports